export enum PaymentLimitRelativeReferenceDate {
  emissionDate = 'emission_date',
  lastDayEmissionMonth = 'last_day_emission_month',
  lastDayDeliveryMonth = 'last_day_of_month_delivery',
}

export enum PaymentLimitRelativeReferenceDateTranslation {
  emissionDate = 'date_issue_radio',
  lastDayEmissionMonth = 'last_day_month_radio',
  lastDayDeliveryMonth = 'last_day_delivery_month_radio',
}

export const getPaymentLimitRelativeReferenceDateFromValue = (value): PaymentLimitRelativeReferenceDate => {
  if (!value) {
    return value;
  }

  const index = Object.values(PaymentLimitRelativeReferenceDate).indexOf(value);
  if (index < 0) {
    throw new Error('Unknown payment limit relative reference date category ' + value);
  }

  return Object.keys(PaymentLimitRelativeReferenceDate)[index] as PaymentLimitRelativeReferenceDate;
};
